import React, { useState } from "react";
import { Clock, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const fmt = (s: string) => new Date(s).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });

export function TrialBanner({ trial, isOwner }: { trial: any; isOwner: boolean }) {
  const [busy, setBusy] = useState(false);
  if (!trial || (trial.state === "trial" && trial.days_left > 7)) return null;
  const subscribe = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { plan: "pro", origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  const msg = trial.state === "trial"
    ? `Your free trial ends ${trial.days_left <= 0 ? "today" : trial.days_left === 1 ? "tomorrow" : `in ${trial.days_left} days`}, on ${fmt(trial.trial_ends_at)}. Subscribe to Pro for $20/month to keep everything running.`
    : trial.state === "grace"
      ? `Your free trial has ended. You have until ${fmt(trial.grace_ends_at)} to subscribe. After that your account is locked, and your events, leads and files are permanently deleted on ${fmt(trial.purge_at)}.`
      : `Your account is locked because the free trial ended. Subscribe to Pro to unlock it. Otherwise your events, leads and files are permanently deleted on ${fmt(trial.purge_at)}.`;
  const tone = trial.state === "trial" ? "border-amber-300 bg-amber-50 text-amber-900" : "border-rose-300 bg-rose-50 text-rose-900";
  const Icon = trial.state === "expired" ? Lock : Clock;
  return (
    <div className={`mb-5 flex flex-col gap-3 rounded-sm border p-4 sm:flex-row sm:items-center ${tone}`} role="alert" data-testid={`trial-banner-${trial.state}`}>
      <Icon className="h-5 w-5 shrink-0" />
      <p className="flex-1 text-sm font-medium" data-testid="trial-banner-message">{msg} {!isOwner && "Please ask your account owner to subscribe."}</p>
      {isOwner && (
        <Button onClick={subscribe} disabled={busy} className="bg-stone-900 text-white hover:bg-stone-800" data-testid="trial-banner-subscribe-button">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Subscribe to Pro"}
        </Button>
      )}
    </div>
  );
}
